import { render, staticRenderFns } from "./storageFacility.vue?vue&type=template&id=2960070b"
import script from "./storageFacility.vue?vue&type=script&lang=js"
export * from "./storageFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2960070b')) {
      api.createRecord('2960070b', component.options)
    } else {
      api.reload('2960070b', component.options)
    }
    module.hot.accept("./storageFacility.vue?vue&type=template&id=2960070b", function () {
      api.rerender('2960070b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/base/storageFacility.vue"
export default component.exports